import { DELETE_ME_EDIT_CP, DELETE_ME_CLEAR_FORM } from "../actions/delete_me_actions";


const initialState = {
  current_password: ''
};


export const deleteMeReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_ME_EDIT_CP: {
      return {
        ...state,
        current_password: action.current_password
      }
    }
    case DELETE_ME_CLEAR_FORM: {
      return {
        ...state,
        current_password: ''
      }
    }
    default:
      return state;
  }
}
